<div
  [style.display]="state().value === 'inactive' ? 'none' : ''"
  class="flex items-center px-lg py-base bg-black dark:bg-white text-white dark:text-black"
  [ngClass]="{ '!bg-error !text-white': toastPackage.toastType === 'toast-error' }"
>
  @if (toastPackage.toastType === 'toast-error') {
    <div class="flex mr-sm">
      <svg-icon key="warning-diamond" class="!text-base"></svg-icon>
    </div>
  }
  <div class="flex-1 text-base leading-base">
    @if (message && options.enableHtml) {
      <div [class]="options.messageClass" [innerHTML]="message"></div>
    }
    @if (message && !options.enableHtml) {
      <div [class]="options.messageClass" [attr.aria-label]="message">
        {{ message }}
      </div>
    }
  </div>
  @if (options.closeButton) {
    <div class="ml-xl flex cursor-pointer">
      <svg-icon key="close" class="!text-sm"></svg-icon>
    </div>
  }
</div>
